import React, { useEffect, useState } from "react";
import Heading from "../../../../common/element/Heading";
import { setBreadcrumbs } from "../../../../redux/classes/breadcrumbsSlice";
import Card from "../../../../common/element/Card";
import { useParams } from "react-router-dom";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ProviderGetAllfavouriteReports, ProviderFavouriteReportsOrNot } from "../../../../actions/provider-portal/reports/ProviderReportsFavOrNot";
import { FetchAllProviderCustomReports, ProviderCustomReports } from "../../../../actions/provider-portal/reports/CustomReportsProviderPortal";
import useUnauthorizedHandler from "../../../../common/snippet/useUnauthorizedHandler";
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";
import ExpiredSubscription from "../../components/template/ExpiredSubscription";
function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="#5786CC"
      className={`h-5 w-5 transition-transform ${!open ? "rotate-180" : ""}`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}

const ProviderProtalReporting = () => {
  const [openAccordions, setOpenAccordions] = useState({
    accordion1: true, // Open by default
    accordion2: true, // Open by default
    accordion3: true, // Open by default
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id, siteId } = useParams();
  const isSubscribed = useSelector((state) => state?.providerSubscription?.isSubscribed);
  const handleUnauthorizedAccess = useUnauthorizedHandler();
  const { ClientSpecificProfileData } = useSelector((state) => state);
  const [favReport, setFavReport] = useState([]);
  const [custReport, setCustReport] = useState([]);
  const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
  let userType;
  let userId;
  if (storedData) {
    userId = storedData?.userName?.user_id;
    userType = storedData?.data?.role?.role_name || "provider"
  }

  // const providerDataArray = [
  // providers - overview    		      Providers Overview
  // compliance - checklist     	    Providers Checklist Overview
  // providers - invoices    		      Providers Invoices
  // workers - under - providers     	Providers’ Workers Documents Overview
  //   ];

  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        {
          label: "Reports",
          url: "/provider/reports",
          home: "/provider/dashboard",
        },
      ])
    );
  }, [dispatch]);

  const toggleAccordion = (accordion) => {
    setOpenAccordions((prevState) => ({
      ...prevState,
      [accordion]: !prevState[accordion],
    }));
  };

  const handleNavigate = (value) => {
    navigate(`${value}`, {
      state: { favReport }, // Pass the favReport state here
    });
  };

  const hanldeCustomNavigate = (value, custReports) => {
    const cstRep = [custReports];
    navigate(`${value}`, {
      state: { favReport, cstRep }, // Pass the favReport state here
    });
  };

  const AllfavouriteReports = () => {
    const payload = {
      user_id: userId,
      report_dashboard: "provider",
    };

    dispatch(ProviderGetAllfavouriteReports(payload))
      .then((res) => {
        if (res.status) {
          // Handle the success response here
          const arrayData = res.data;

          setFavReport(arrayData);
        } else {
          // Handle non-successful status codes here
          console.error(
            "Failed to favorite report:",
            res.message || "Unknown error"
          );
        }
      })
      .catch((error) => {
        // Handle the error (e.g., network error, server error, etc.)
        console.error("Error favoriting report:", error);
        // Optionally show a user-friendly message
      });
  };

  const handleFavReports = (reportType, reportTitle, isFav) => {
    const payload = {
      user_id: userId,
      report_type: reportType,
      is_favourite: isFav,
      user_type: userType,
      report_dashboard: "provider",
      report_title: reportTitle,
    };
    dispatch(ProviderFavouriteReportsOrNot(payload))
      .then((res) => {
        if (res.status) {
          // Handle the success response here
          AllfavouriteReports(); // Call this api
        } else {
          // Handle non-successful status codes here
          console.error(
            "Failed to favorite report:",
            res.message || "Unknown error"
          );
        }
      })
      .catch((error) => {
        // Handle the error (e.g., network error, server error, etc.)
        console.error("Error favoriting report:", error);
        // Optionally show a user-friendly message
      });
  };
  const FetchAllCustomReport = () => {
    const payload = {
      user_id: userId,
      report_dashboard: "provider",
    };

    dispatch(FetchAllProviderCustomReports(payload))
      .then((res) => {
        if (res.status) {
          // Handle the success response here
          const arrayData = res.data;
     
          setCustReport(arrayData);
        } else {
          // Handle non-successful status codes here
          console.error(
            "Failed to favorite report:",
            res.message || "Unknown error"
          );
        }
      })
      .catch((error) => {
        // Handle the error (e.g., network error, server error, etc.)
        console.error("Error favoriting report:", error);
        // Optionally show a user-friendly message
      });
  };
  const handleCustReports = () => { };
  useEffect(() => {
    AllfavouriteReports();
    FetchAllCustomReport();
  }, [dispatch]);
  return (
    <React.Fragment>
      {isSubscribed ? <ExpiredSubscription /> :
        <>
          <div className="flex justify-between mb-5 border-b border-gray-200 pb-5">
            <Heading>Reports</Heading>
          </div>

          {/* Favourites Accordion */}
          <Accordion
            open={openAccordions.accordion1}
            icon={<Icon id={1} open={openAccordions.accordion1} />}
          >
            <AccordionHeader
              onClick={() => toggleAccordion("accordion1")}
              className="border-0 text-base"
            >
              Favourites
            </AccordionHeader>
            <AccordionBody>
              <div className="flex gap-5 mb-5 flex-wrap">
                {favReport && favReport.length ? (
                  favReport.map((report, favourite_reports_id) => (
                    <Card
                      key={favourite_reports_id} // key helps React identify which items have changed, are added, or are removed
                      clickable
                      className="width-30 flex justify-between rounded-xl card-shadows border border-gray-200 p-5 hover:shadow-lg transition duration-150 ease-in-out"
                      onClick={() => handleNavigate(report?.report_type)}
                    >
                      <div
                        className="cursor-pointer"
                        onClick={() => handleNavigate(report?.report_type)}
                      >
                        <h5 className="font-semibold text-gray-800 text-base">
                          {report.report_title}
                        </h5>
                        {/* <p className="mt-2 text-xs">
                          Description lorem ipsum dolor sit amet consectetur. Mauris
                          vulputate.
                        </p> */}
                      </div>
                      <span>
                        <svg
                          onClick={() =>
                            handleFavReports(
                              report.report_type,
                              report.title,
                              !report.is_favourite
                            )
                          }
                          width="21"
                          height="21"
                          viewBox="0 0 21 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_15736_74961)">
                            <path
                              d="M9.87232 2.41075C10.0431 2.0001 10.6248 2.0001 10.7956 2.41075L12.8617 7.37822C12.9337 7.55134 13.0965 7.66963 13.2834 7.68461L18.6462 8.11454C19.0896 8.15009 19.2693 8.70334 18.9316 8.99267L14.8457 12.4927C14.7033 12.6147 14.6411 12.806 14.6846 12.9884L15.9329 18.2216C16.0361 18.6542 15.5655 18.9962 15.1859 18.7643L10.5946 15.96C10.4346 15.8622 10.2334 15.8622 10.0734 15.96L5.48204 18.7643C5.10249 18.9962 4.63187 18.6542 4.73506 18.2216L5.98337 12.9884C6.02687 12.806 5.96469 12.6147 5.82229 12.4927L1.7364 8.99267C1.39863 8.70334 1.57839 8.15009 2.02172 8.11454L7.38453 7.68461C7.57142 7.66963 7.73423 7.55134 7.80623 7.37822L9.87232 2.41075Z"
                              fill="#FDB022"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_15736_74961">
                              <rect
                                width="20"
                                height="20"
                                fill="white"
                                transform="translate(0.333984 0.800781)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                    </Card>
                  ))
                ) : (
                  <div className="h-full w-full text-center mt-2">
                    No data available
                  </div>
                )}
              </div>
            </AccordionBody>
          </Accordion>

          {/* Custom Reports Accordion */}
          <Accordion
            open={openAccordions.accordion2}
            icon={<Icon id={2} open={openAccordions.accordion2} />}
          >
            <AccordionHeader
              onClick={() => toggleAccordion("accordion2")}
              className="border-0 text-base"
            >
              Custom reports
            </AccordionHeader>
            <AccordionBody>
              <div className="flex gap-5 mb-5 flex-wrap">
                {custReport && custReport.length ? (
                  custReport.map((report, favourite_reports_id) => (
                    <Card
                      key={favourite_reports_id} // key helps React identify which items have changed, are added, or are removed
                      clickable
                      className="width-30 flex justify-between rounded-xl card-shadows border border-gray-200 p-5 hover:shadow-lg transition duration-150 ease-in-out"
                      onClick={() =>
                        hanldeCustomNavigate(report?.report_type, report)
                      }
                    >
                      <div
                        className="cursor-pointer"
                        onClick={() =>
                          hanldeCustomNavigate(report?.report_type, report)
                        }
                      >
                        <h5 className="font-semibold text-gray-800 text-base">
                          {report && report.custom_report_name
                            ? `${report.report_title} (${report.custom_report_name})`
                            : report.report_title}
                        </h5>
                        {/* <p className="mt-2 text-xs">
                          Description lorem ipsum dolor sit amet consectetur. Mauris
                          vulputate.
                        </p> */}
                      </div>
                      <span>
                        <svg
                          onClick={() =>
                            handleCustReports(
                              report.report_type,
                              report.title,
                              !report.is_custom
                            )
                          }
                          width="21"
                          height="21"
                          viewBox="0 0 21 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_15736_74961)">
                            <path
                              d="M9.87232 2.41075C10.0431 2.0001 10.6248 2.0001 10.7956 2.41075L12.8617 7.37822C12.9337 7.55134 13.0965 7.66963 13.2834 7.68461L18.6462 8.11454C19.0896 8.15009 19.2693 8.70334 18.9316 8.99267L14.8457 12.4927C14.7033 12.6147 14.6411 12.806 14.6846 12.9884L15.9329 18.2216C16.0361 18.6542 15.5655 18.9962 15.1859 18.7643L10.5946 15.96C10.4346 15.8622 10.2334 15.8622 10.0734 15.96L5.48204 18.7643C5.10249 18.9962 4.63187 18.6542 4.73506 18.2216L5.98337 12.9884C6.02687 12.806 5.96469 12.6147 5.82229 12.4927L1.7364 8.99267C1.39863 8.70334 1.57839 8.15009 2.02172 8.11454L7.38453 7.68461C7.57142 7.66963 7.73423 7.55134 7.80623 7.37822L9.87232 2.41075Z"
                              fill="#FDB022"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_15736_74961">
                              <rect
                                width="20"
                                height="20"
                                fill="white"
                                transform="translate(0.333984 0.800781)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                    </Card>
                  ))
                ) : (
                  <div className="h-full w-full text-center mt-2">
                    No data available
                  </div>
                )}
              </div>
            </AccordionBody>
          </Accordion>

          {/* Standard Reports Accordion */}
          <Accordion
            open={openAccordions.accordion3}
            icon={<Icon id={3} open={openAccordions.accordion3} />}
          >
            <AccordionHeader
              onClick={() => toggleAccordion("accordion3")}
              className="border-0 text-base"
            >
              Standard reports
            </AccordionHeader>
            <AccordionBody>
              <div className="flex gap-5 mb-5">
                {/* <Card
              clickable
              className="w-1/3 flex justify-between rounded-xl card-shadows border border-gray-200 p-5 hover:shadow-lg transition duration-150 ease-in-out"
            >
              <div
                className="cursor-pointer"
                onClick={() => handleNavigate("providers-overview")}
              >
                <h5 className="font-semibold text-gray-800 text-base">
                  Providers Overview
                </h5>
                <p className="mt-2 text-xs">
                  Description lorem ipsum dolor sit amet consectetur. Mauris
                  vulputate.
                </p>
              </div>
              <span>
                {favReport &&
                favReport.length &&
                favReport.some(
                  (ele) => ele.report_type == "providers-overview"
                ) ? (
                  <svg
                    onClick={() =>
                      handleFavReports(
                        "providers-overview",
                        "Providers Overview",
                        false
                      )
                    }
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_15736_74961)">
                      <path
                        d="M9.87232 2.41075C10.0431 2.0001 10.6248 2.0001 10.7956 2.41075L12.8617 7.37822C12.9337 7.55134 13.0965 7.66963 13.2834 7.68461L18.6462 8.11454C19.0896 8.15009 19.2693 8.70334 18.9316 8.99267L14.8457 12.4927C14.7033 12.6147 14.6411 12.806 14.6846 12.9884L15.9329 18.2216C16.0361 18.6542 15.5655 18.9962 15.1859 18.7643L10.5946 15.96C10.4346 15.8622 10.2334 15.8622 10.0734 15.96L5.48204 18.7643C5.10249 18.9962 4.63187 18.6542 4.73506 18.2216L5.98337 12.9884C6.02687 12.806 5.96469 12.6147 5.82229 12.4927L1.7364 8.99267C1.39863 8.70334 1.57839 8.15009 2.02172 8.11454L7.38453 7.68461C7.57142 7.66963 7.73423 7.55134 7.80623 7.37822L9.87232 2.41075Z"
                        fill="#FDB022"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_15736_74961">
                        <rect
                          width="20"
                          height="20"
                          fill="white"
                          transform="translate(0.333984 0.800781)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                ) : (
                  <svg
                    onClick={() =>
                      handleFavReports(
                        "providers-overview",
                        "Providers Overview",
                        true
                      )
                    }
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_15736_74961)">
                      <path
                        d="M9.87232 2.41075C10.0431 2.0001 10.6248 2.0001 10.7956 2.41075L12.8617 7.37822C12.9337 7.55134 13.0965 7.66963 13.2834 7.68461L18.6462 8.11454C19.0896 8.15009 19.2693 8.70334 18.9316 8.99267L14.8457 12.4927C14.7033 12.6147 14.6411 12.806 14.6846 12.9884L15.9329 18.2216C16.0361 18.6542 15.5655 18.9962 15.1859 18.7643L10.5946 15.96C10.4346 15.8622 10.2334 15.8622 10.0734 15.96L5.48204 18.7643C5.10249 18.9962 4.63187 18.6542 4.73506 18.2216L5.98337 12.9884C6.02687 12.806 5.96469 12.6147 5.82229 12.4927L1.7364 8.99267C1.39863 8.70334 1.57839 8.15009 2.02172 8.11454L7.38453 7.68461C7.57142 7.66963 7.73423 7.55134 7.80623 7.37822L9.87232 2.41075Z"
                        fill="#EAECF0"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_15736_74961">
                        <rect
                          width="20"
                          height="20"
                          fill="white"
                          transform="translate(0.333984 0.800781)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                )}
              </span>
            </Card> */}
                <Card
                  clickable
                  className="w-1/3 flex justify-between rounded-xl card-shadows border border-gray-200 p-5 hover:shadow-lg transition duration-150 ease-in-out"
                  onClick={(e) => console.log("Card Clickable", e)}
                >
                  <div
                    className="cursor-pointer"
                    onClick={() => handleNavigate("compliance-checklist")}
                  >
                    <h5 className="font-semibold text-gray-800 text-base">
                      Providers Compliance Checklist
                    </h5>
                    {/* <p className="mt-2 text-xs">
                      Description lorem ipsum dolor sit amet consectetur. Mauris
                      vulputate.
                    </p> */}
                  </div>
                  <span>
                    {favReport &&
                      favReport.length &&
                      favReport.some(
                        (ele) => ele.report_type == "compliance-checklist"
                      ) ? (
                      <svg
                        onClick={() =>
                          handleFavReports(
                            "compliance-checklist",
                            "Providers Compliance Checklist",
                            false
                          )
                        }
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_15736_74961)">
                          <path
                            d="M9.87232 2.41075C10.0431 2.0001 10.6248 2.0001 10.7956 2.41075L12.8617 7.37822C12.9337 7.55134 13.0965 7.66963 13.2834 7.68461L18.6462 8.11454C19.0896 8.15009 19.2693 8.70334 18.9316 8.99267L14.8457 12.4927C14.7033 12.6147 14.6411 12.806 14.6846 12.9884L15.9329 18.2216C16.0361 18.6542 15.5655 18.9962 15.1859 18.7643L10.5946 15.96C10.4346 15.8622 10.2334 15.8622 10.0734 15.96L5.48204 18.7643C5.10249 18.9962 4.63187 18.6542 4.73506 18.2216L5.98337 12.9884C6.02687 12.806 5.96469 12.6147 5.82229 12.4927L1.7364 8.99267C1.39863 8.70334 1.57839 8.15009 2.02172 8.11454L7.38453 7.68461C7.57142 7.66963 7.73423 7.55134 7.80623 7.37822L9.87232 2.41075Z"
                            fill="#FDB022"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_15736_74961">
                            <rect
                              width="20"
                              height="20"
                              fill="white"
                              transform="translate(0.333984 0.800781)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    ) : (
                      <svg
                        onClick={() =>
                          handleFavReports(
                            "compliance-checklist",
                            "Providers Compliance Checklist",
                            true
                          )
                        }
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_15736_74961)">
                          <path
                            d="M9.87232 2.41075C10.0431 2.0001 10.6248 2.0001 10.7956 2.41075L12.8617 7.37822C12.9337 7.55134 13.0965 7.66963 13.2834 7.68461L18.6462 8.11454C19.0896 8.15009 19.2693 8.70334 18.9316 8.99267L14.8457 12.4927C14.7033 12.6147 14.6411 12.806 14.6846 12.9884L15.9329 18.2216C16.0361 18.6542 15.5655 18.9962 15.1859 18.7643L10.5946 15.96C10.4346 15.8622 10.2334 15.8622 10.0734 15.96L5.48204 18.7643C5.10249 18.9962 4.63187 18.6542 4.73506 18.2216L5.98337 12.9884C6.02687 12.806 5.96469 12.6147 5.82229 12.4927L1.7364 8.99267C1.39863 8.70334 1.57839 8.15009 2.02172 8.11454L7.38453 7.68461C7.57142 7.66963 7.73423 7.55134 7.80623 7.37822L9.87232 2.41075Z"
                            fill="#EAECF0"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_15736_74961">
                            <rect
                              width="20"
                              height="20"
                              fill="white"
                              transform="translate(0.333984 0.800781)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </span>
                </Card>
                <Card
                  clickable
                  className="w-1/3 flex justify-between rounded-xl card-shadows border border-gray-200 p-5 hover:shadow-lg transition duration-150 ease-in-out"
                  onClick={(e) => console.log("Card Clickable", e)}
                >
                  <div
                    className="cursor-pointer"
                    onClick={() => handleNavigate("providers-invoices")}
                  >
                    <h5 className="font-semibold text-gray-800 text-base">
                      Providers Invoices
                    </h5>
                    {/* <p className="mt-2 text-xs">
                      Description lorem ipsum dolor sit amet consectetur. Mauris
                      vulputate.
                    </p> */}
                  </div>
                  <span>
                    {favReport &&
                      favReport.length &&
                      favReport.some(
                        (ele) => ele.report_type == "providers-invoices"
                      ) ? (
                      <svg
                        onClick={() =>
                          handleFavReports(
                            "providers-invoices",
                            "Providers Invoices",
                            false
                          )
                        }
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_15736_74961)">
                          <path
                            d="M9.87232 2.41075C10.0431 2.0001 10.6248 2.0001 10.7956 2.41075L12.8617 7.37822C12.9337 7.55134 13.0965 7.66963 13.2834 7.68461L18.6462 8.11454C19.0896 8.15009 19.2693 8.70334 18.9316 8.99267L14.8457 12.4927C14.7033 12.6147 14.6411 12.806 14.6846 12.9884L15.9329 18.2216C16.0361 18.6542 15.5655 18.9962 15.1859 18.7643L10.5946 15.96C10.4346 15.8622 10.2334 15.8622 10.0734 15.96L5.48204 18.7643C5.10249 18.9962 4.63187 18.6542 4.73506 18.2216L5.98337 12.9884C6.02687 12.806 5.96469 12.6147 5.82229 12.4927L1.7364 8.99267C1.39863 8.70334 1.57839 8.15009 2.02172 8.11454L7.38453 7.68461C7.57142 7.66963 7.73423 7.55134 7.80623 7.37822L9.87232 2.41075Z"
                            fill="#FDB022"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_15736_74961">
                            <rect
                              width="20"
                              height="20"
                              fill="white"
                              transform="translate(0.333984 0.800781)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    ) : (
                      <svg
                        onClick={() =>
                          handleFavReports(
                            "providers-invoices",
                            "Providers Invoices",
                            true
                          )
                        }
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_15736_74961)">
                          <path
                            d="M9.87232 2.41075C10.0431 2.0001 10.6248 2.0001 10.7956 2.41075L12.8617 7.37822C12.9337 7.55134 13.0965 7.66963 13.2834 7.68461L18.6462 8.11454C19.0896 8.15009 19.2693 8.70334 18.9316 8.99267L14.8457 12.4927C14.7033 12.6147 14.6411 12.806 14.6846 12.9884L15.9329 18.2216C16.0361 18.6542 15.5655 18.9962 15.1859 18.7643L10.5946 15.96C10.4346 15.8622 10.2334 15.8622 10.0734 15.96L5.48204 18.7643C5.10249 18.9962 4.63187 18.6542 4.73506 18.2216L5.98337 12.9884C6.02687 12.806 5.96469 12.6147 5.82229 12.4927L1.7364 8.99267C1.39863 8.70334 1.57839 8.15009 2.02172 8.11454L7.38453 7.68461C7.57142 7.66963 7.73423 7.55134 7.80623 7.37822L9.87232 2.41075Z"
                            fill="#EAECF0"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_15736_74961">
                            <rect
                              width="20"
                              height="20"
                              fill="white"
                              transform="translate(0.333984 0.800781)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </span>
                </Card>
                <Card
                  clickable
                  className="w-1/3 flex justify-between rounded-xl card-shadows border border-gray-200 p-5 hover:shadow-lg transition duration-150 ease-in-out"
                  onClick={(e) => console.log("Card Clickable", e)}
                >
                  <div
                    className="cursor-pointer"
                    onClick={() => handleNavigate("workers-under-providers")}
                  >
                    <h5 className="font-semibold text-gray-800 text-base">
                      Providers’ Workers Documents Overview
                    </h5>
                    {/* <p className="mt-2 text-xs">
                      Description lorem ipsum dolor sit amet consectetur. Mauris
                      vulputate.
                    </p> */}
                  </div>
                  <span>
                    {favReport &&
                      favReport.length &&
                      favReport.some(
                        (ele) => ele.report_type == "workers-under-providers"
                      ) ? (
                      <svg
                        onClick={() =>
                          handleFavReports(
                            "workers-under-providers",
                            "Providers’ Workers Documents Overview",
                            false
                          )
                        }
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_15736_74961)">
                          <path
                            d="M9.87232 2.41075C10.0431 2.0001 10.6248 2.0001 10.7956 2.41075L12.8617 7.37822C12.9337 7.55134 13.0965 7.66963 13.2834 7.68461L18.6462 8.11454C19.0896 8.15009 19.2693 8.70334 18.9316 8.99267L14.8457 12.4927C14.7033 12.6147 14.6411 12.806 14.6846 12.9884L15.9329 18.2216C16.0361 18.6542 15.5655 18.9962 15.1859 18.7643L10.5946 15.96C10.4346 15.8622 10.2334 15.8622 10.0734 15.96L5.48204 18.7643C5.10249 18.9962 4.63187 18.6542 4.73506 18.2216L5.98337 12.9884C6.02687 12.806 5.96469 12.6147 5.82229 12.4927L1.7364 8.99267C1.39863 8.70334 1.57839 8.15009 2.02172 8.11454L7.38453 7.68461C7.57142 7.66963 7.73423 7.55134 7.80623 7.37822L9.87232 2.41075Z"
                            fill="#FDB022"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_15736_74961">
                            <rect
                              width="20"
                              height="20"
                              fill="white"
                              transform="translate(0.333984 0.800781)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    ) : (
                      <svg
                        onClick={() =>
                          handleFavReports(
                            "workers-under-providers",
                            "Providers’ Workers Documents Overview",
                            true
                          )
                        }
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_15736_74961)">
                          <path
                            d="M9.87232 2.41075C10.0431 2.0001 10.6248 2.0001 10.7956 2.41075L12.8617 7.37822C12.9337 7.55134 13.0965 7.66963 13.2834 7.68461L18.6462 8.11454C19.0896 8.15009 19.2693 8.70334 18.9316 8.99267L14.8457 12.4927C14.7033 12.6147 14.6411 12.806 14.6846 12.9884L15.9329 18.2216C16.0361 18.6542 15.5655 18.9962 15.1859 18.7643L10.5946 15.96C10.4346 15.8622 10.2334 15.8622 10.0734 15.96L5.48204 18.7643C5.10249 18.9962 4.63187 18.6542 4.73506 18.2216L5.98337 12.9884C6.02687 12.806 5.96469 12.6147 5.82229 12.4927L1.7364 8.99267C1.39863 8.70334 1.57839 8.15009 2.02172 8.11454L7.38453 7.68461C7.57142 7.66963 7.73423 7.55134 7.80623 7.37822L9.87232 2.41075Z"
                            fill="#EAECF0"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_15736_74961">
                            <rect
                              width="20"
                              height="20"
                              fill="white"
                              transform="translate(0.333984 0.800781)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </span>
                </Card>
              </div>
            </AccordionBody>
          </Accordion>
        </>
      }
    </React.Fragment>
  );
};
export default ProviderProtalReporting;
